<template lang="html">
  <transition name="fade" mode="out-in">
    <div v-if="active" class="overlay">
      <div class="overlay-inner">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Overlay',

    props: {
      active: Boolean
    }
  }
</script>

<style lang="sass">
  @import '../../styles/base/variables'
  @import '../../styles/helpers/mixins'

  .overlay
    position: fixed
    top: 0
    left: 0
    bottom: 0
    right: 0
    display: flex
    align-items: center
    justify-content: center
    z-index: 900
    background: rgba(0, 0, 0, 0.4)
    color: $color-body-bg

    .overlay-inner
      position: relative

    .btn
      color: $color-text
      border-color: $color-primary

      &.is-primary
        color: $color-button-text

    .card
      border-radius: 5px
      padding: 30px
      background: $color-panel-bg
      box-shadow: 0 0 5px 0px $color-shadow

      @include media($media-small)
        min-width: 500px

      @include media($media-medium)
        min-width: 800px

    .close-btn
      position: absolute
      top: 15px
      right: 15px
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Overlay.vue